import {SET_LEAD_ID} from "@/store/slices/leadSlice";
import axios from "axios";
import Apm from "@/utils/Apm";
import { createPedidoLead } from "@/api/assine";

let source = axios.CancelToken.source();
let timeout: NodeJS.Timeout;
let last_save_lead: any = {};

interface ILead {
    save: (leadData: {
        [key: string]: any
    }, dispatch: any) => void
}

const Lead: ILead = {
    save: (leadData: {[key: string]: any}, dispatch: any) => {
        if(Object.keys(leadData).find((key) => {
            return leadData?.[key] !== last_save_lead?.[key]
        })){
            last_save_lead = leadData;
            source.cancel('Operation canceled by the user.');
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                source = axios.CancelToken.source();
                createPedidoLead(leadData, true)
                    .then((data) => {
                        let leadID = 0
                        if(typeof data === 'number'){
                            leadID = data
                        }else if(typeof data ==='string'){
                            leadID = parseInt(data)
                        }else{
                            Apm.captureError("DATA NÃO ERA UMA STRING NEM UM NUMBER EM LEAD!")
                            return
                        }

                        last_save_lead = {
                            ...leadData,
                            idLead: leadID
                        };
                        dispatch(SET_LEAD_ID(leadID));
                }).catch((e) => {
                    Apm.captureError(`Lead -> save(): ${e}`);
                })
            }, 1000);
        }
    }
}

export default Lead;